import { QRCodeSVG } from 'qrcode.react';
import { API } from '@unboared/react';
import classNames from 'classnames';

import styles from './QRCodeViewORY.module.css';

export default function QRCodeViewORY() {
    return (
        <div className={styles.container}>
            <video className={styles.video} src="/assets/video/UB_Extime.mp4" autoPlay loop muted playsInline />
            <div className={classNames(styles.qrContainer, styles.qr)}>
                <h2 className={styles.title}>SCAN TO PLAY</h2>
                <p className={styles.subtitle}>SCANNEZ POUR JOUER</p>
                <QRCodeSVG className={styles.qrcode} value={API.getSessionLink()} />
            </div>
        </div>
    );
}
